import config from "./Config/config";

require('./base');

import Order from "./Components/basket/order";

require('./Components/suggestions');

import {calculator} from "./Components/basket/Calculator/DefaultCalculator";
import {getCartData} from "./Components/basket/get-cart-data";
import updateItem from "./Components/basket/updateItem";
import {deleteFromBasket} from "./Components/basket/deleteFromBasket";
import {changeInputFile} from "./Components/input-file";

import events from "./base";

new Order(events);

const state = {
    index: '',
    deliveryIndex: '',
    isUpdatedDelivery: true,
    coupon: '',
    deliveryPrice: 0,
    packingPrice: 0,
    PaymentVariant: '',
    carData: undefined
};

const updaterCartInfo = () => {
    if (!state.carData) {
        getCartData(state.coupon, state.PaymentVariant).then(e => {
            state.carData = e;
            events.dispatch(config.listeners.basket.added, state.carData, state.deliveryPrice, state.packingPrice, state.PaymentVariant);
        });
    } else {
        events.dispatch(config.listeners.basket.added, state.carData, state.deliveryPrice, state.packingPrice, state.PaymentVariant);
    }
};

const setCartData = cartData => {
    state.carData = cartData;
    updaterCartInfo();
};

const setCartDataWitchClearDeliveryAndPackingPrice = cartData => {
    setCartData(cartData);
};

let calc = calculator(events);
calc.init('section .basket .js_item');

events.addListener('item.deleted', null, calc.delete.bind(calc));
events.addListener('item.deleted', null, (e, j) => setCartDataWitchClearDeliveryAndPackingPrice(j));

events.addListener('paper.update', null, (element, data) => updateItem(element, data, state.coupon, state.PaymentVariant, events));

events.addListener('item.updated', null, e => setCartDataWitchClearDeliveryAndPackingPrice(e));

document.querySelectorAll('.js_del_good_cart')
    .forEach(item => item.addEventListener('click', event => {
        deleteFromBasket(event, state.coupon, state.PaymentVariant, events);
    }));

document.querySelectorAll('.js_delivery_tab').forEach(item => {
    item.addEventListener('click', () => {
        document.querySelector('[name="delivery_variant"]').value = item.dataset.id;
    });
});

document.querySelectorAll('input[type="file"]').forEach(el => {
    if (el.getAttribute('type') === 'file') {
        el.addEventListener('change', () => changeInputFile(el));
    }
});

updaterCartInfo();
let d = new Date();
let loc = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());


const inputTimeZone = document.createElement('input');
inputTimeZone.type = 'hidden';
inputTimeZone.value = ((document.body.dataset.time - loc / 1000) / 3600).toFixed(0);
inputTimeZone.name = "user_data_time_zone";
document.body.append(inputTimeZone);